import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaPoolHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaPoolHeater} />; }
